import manifest from "./season-manifest.json";

// Encounter slug => WCL encounter id mappings, from the season manifest owned
// by the exodia backend (Common.SeasonManifest, published as manifest.json
// with the aggregation output). Resync with `yarn sync-manifest`.
export const ENCOUNTER_IDS = manifest.encounters;
